'use client';

import { useEffect, useRef } from 'react';
import { useRouter, useSearchParams } from 'next/navigation';
import { signIn } from 'next-auth/react';
import { useTranslate } from '@tolgee/react';

import { AuthSpinner } from '~/shared/components/AuthSpinner';

export const RedirectContent = () => {
  const hasRedirectedToSignIn = useRef(false);
  const searchParams = useSearchParams();
  const router = useRouter();
  const { t } = useTranslate();

  const errorMessage = searchParams?.get('error');
  const callbackUrl = searchParams?.get('callbackUrl') ?? '/';

  useEffect(() => {
    if (errorMessage) {
      router.push(`/auth/error?error=${encodeURIComponent(errorMessage)}`);
      return;
    }

    if (!hasRedirectedToSignIn.current) {
      hasRedirectedToSignIn.current = true;
      signIn('azure-ad', { callbackUrl }).catch(err => {
        // eslint-disable-next-line no-console
        console.error('Error redirecting to SSO:', err);
      });
    }
  }, [callbackUrl, errorMessage, router]);

  return (
    <div className="flex min-h-0 w-full flex-1 flex-col items-center justify-center bg-gray-50 font-sans">
      <div className="mb-8">
        <AuthSpinner />
      </div>
      <p className="text-center text-xl font-semibold text-gray-700">
        {t('redirect_content.signing')}
      </p>
    </div>
  );
};
